import React from 'react';
import { FileText, Plus, Download, Mail, Eye, DollarSign } from 'lucide-react';
export function Invoicing() {
  return <div className="space-y-8 max-w-[1600px] mx-auto" data-id="element-1362">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1363">
        <div data-id="element-1364">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-1365">
            Manual Invoicing
          </h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-1366">
            Bill for custom services like graphic design or consulting.
          </p>
        </div>
        <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-1367">
          <Plus size={18} data-id="element-1368" />
          Create New Invoice
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1369">
        <div className="lg:col-span-2 bg-white p-8 rounded-lg border border-gray-200 shadow-sm space-y-8" data-id="element-1370">
          <div className="grid grid-cols-2 gap-8" data-id="element-1371">
            <div className="space-y-2" data-id="element-1372">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1373">
                Client
              </label>
              <select className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none appearance-none" data-id="element-1374">
                <option data-id="element-1375">Global Tech Solutions</option>
                <option data-id="element-1376">Toronto Creative Hub</option>
                <option data-id="element-1377">New York FinTech</option>
              </select>
            </div>
            <div className="space-y-2" data-id="element-1378">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1379">
                Due Date
              </label>
              <input type="date" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-1380" />
            </div>
          </div>

          <div className="space-y-4" data-id="element-1381">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-1382">Invoice Items</h3>
            <div className="space-y-3" data-id="element-1383">
              <div className="grid grid-cols-12 gap-4 items-center" data-id="element-1384">
                <div className="col-span-7" data-id="element-1385">
                  <input type="text" placeholder="Description" className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm" data-id="element-1386" />
                </div>
                <div className="col-span-2" data-id="element-1387">
                  <input type="number" placeholder="Qty" className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm" data-id="element-1388" />
                </div>
                <div className="col-span-3" data-id="element-1389">
                  <input type="number" placeholder="Price" className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm" data-id="element-1390" />
                </div>
              </div>
            </div>
            <button className="text-xs font-bold text-indigo-600 flex items-center gap-1 hover:underline" data-id="element-1391">
              <Plus size={14} data-id="element-1392" /> Add Item
            </button>
          </div>
        </div>

        <div className="space-y-6" data-id="element-1393">
          <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm space-y-4" data-id="element-1394">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-1395">
              Branded Preview
            </h3>
            <div className="aspect-[3/4] bg-gray-50 rounded-lg border border-gray-100 p-4 flex flex-col" data-id="element-1396">
              <div className="flex justify-between items-start mb-8" data-id="element-1397">
                <div className="w-12 h-12 bg-indigo-600 rounded flex items-center justify-center text-white font-bold" data-id="element-1398">
                  N
                </div>
                <div className="text-right" data-id="element-1399">
                  <p className="text-[10px] font-bold text-slate-900" data-id="element-1400">
                    INVOICE
                  </p>
                  <p className="text-[8px] text-gray-400" data-id="element-1401">#INV-2023-001</p>
                </div>
              </div>
              <div className="space-y-2 mb-8" data-id="element-1402">
                <div className="h-2 w-24 bg-gray-200 rounded" data-id="element-1403"></div>
                <div className="h-2 w-32 bg-gray-100 rounded" data-id="element-1404"></div>
              </div>
              <div className="flex-1 space-y-3" data-id="element-1405">
                <div className="h-4 w-full bg-white rounded border border-gray-100" data-id="element-1406"></div>
                <div className="h-4 w-full bg-white rounded border border-gray-100" data-id="element-1407"></div>
              </div>
              <div className="pt-4 border-t border-gray-100 flex justify-between" data-id="element-1408">
                <span className="text-[10px] font-bold" data-id="element-1409">Total</span>
                <span className="text-[10px] font-bold text-indigo-600" data-id="element-1410">
                  $0.00
                </span>
              </div>
            </div>
            <div className="flex gap-2" data-id="element-1411">
              <button className="flex-1 py-2 bg-gray-50 text-gray-600 rounded-lg text-xs font-bold border border-gray-200 flex items-center justify-center gap-2" data-id="element-1412">
                <Download size={14} data-id="element-1413" /> PDF
              </button>
              <button className="flex-1 py-2 bg-indigo-600 text-white rounded-lg text-xs font-bold flex items-center justify-center gap-2" data-id="element-1414">
                <Mail size={14} data-id="element-1415" /> Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}